module.exports = {"110101001":"东华门街道","110101002":"景山街道","110101003":"交道口街道","110101004":"安定门街道","110101005":"北新桥街道","110101006":"东四街道","110101007":"朝阳门街道","110101008":"建国门街道","110101009":"东直门街道","110101010":"和平里街道","110101011":"前门街道","110101012":"崇文门外街道","110101013":"东花市街道","110101014":"龙潭街道","110101015":"体育馆路街道","110101016":"天坛街道","110101017":"永定门外街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110101.json
// module id = 107
// module chunks = 0